export default __webpack_public_path__ + "static/media/revision2.93d45465.png";